import {
  List,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/system";

export const IttechCustomJoins = () => {
  return (
    <>
      <Grid container spacing={5} alignItems="center">
        <Grid size={6}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Waarom is één grote tabel onhandig?
          </Typography>
          <Typography variant="h4" sx={{ mb: 2 }}>
            Tabel: GameScores
          </Typography>
          <Table
            size="medium"
            sx={{
              th: {
                fontWeight: "bold",
                borderRight: "1px solid #000",
                fontSize: "2.2em",
                background: "#ddd",
              },
              td: {
                borderRight: "1px solid #000",
                fontSize: "2em",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Speler</TableCell>
                <TableCell>Game</TableCell>
                <TableCell>Platform</TableCell>
                <TableCell>Score</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Data gebaseerd op reader pagina 43 */}
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>LunaByte</TableCell>
                <TableCell>Fortnite</TableCell>
                <TableCell>PC</TableCell>
                <TableCell>950</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>PixelPete</TableCell>
                <TableCell>Minecraft</TableCell>
                <TableCell>PC</TableCell>
                <TableCell>870</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>3</TableCell>
                <TableCell>SkyGamer</TableCell>
                <TableCell>Fortnite</TableCell>
                <TableCell>Xbox</TableCell>
                <TableCell>1030</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>4</TableCell>
                <TableCell>LunaByte</TableCell>
                <TableCell>Fortnite</TableCell>
                <TableCell>PC</TableCell>
                <TableCell>1120</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>5</TableCell>
                <TableCell>SkyGamer</TableCell>
                <TableCell>Minecraft</TableCell>
                <TableCell>Xbox</TableCell>
                <TableCell>940</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        <Grid size={6}>
          <List sx={{ fontSize: "2.2em" }}>
            <ListItem sx={{ fontWeight: "bold" }}>
              1. Dubbel werk (Redundantie)
            </ListItem>
            <ListItem sx={{ pl: 10 }}>
              De gamenaam "Fortnite" staat nu al 3 keer in de tabel. Dat kost
              onnodig veel ruimte als je miljoenen spelers hebt.
            </ListItem>

            <ListItem sx={{ fontWeight: "bold" }}>
              2. Gevoelig voor fouten
            </ListItem>
            <ListItem sx={{ pl: 10 }}>
              Als iemand per ongeluk "Fortnight" typt, ziet de database dit als
              een compleet nieuwe game. Je overzichten kloppen dan niet meer.
            </ListItem>

            <ListItem sx={{ fontWeight: "bold" }}>
              3. Lastig bij wijzigingen
            </ListItem>
            <ListItem sx={{ pl: 10 }}>
              Stel dat "Minecraft" van naam verandert; dan moet je dat in álle
              rijen gaan aanpassen.
            </ListItem>

            <ListItem sx={{ fontWeight: "bold" }}>
              De Oplossing: Normaliseren
            </ListItem>
            <ListItem sx={{ pl: 10 }}>
              We splitsen dit op in twee logische tabellen: <br /> 'Games' en
              'GameScores' <br />
              Zo hoef je de naam van een game maar één keer op te slaan.
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </>
  );
};
